<div class="page-heading modal-content-header">
    <h1 class="layer-title">{{ header }}</h1>
</div>

<div class="modal-content-body">
    <div>
        <div class="row">
            <div class="col-sm-2">Date de début</div>
            <div class="col-sm-2">Date de fin (Abo)</div>
            <div class="col-sm-2">Emission</div>
            <div class="col-sm-2">Montant HT</div>
            <div class="col-sm-1">Emise ?</div>
            <div class="col-sm-1">N°Facture</div>
            <div class="col-sm-2">Motif</div>
        </div>
        @for( b of billingList ; track b.id){
            <div class="row">
                <div class="col-sm-2">
                    <ed-datepicker
                        id="startDate"
                        [ngModel]="b.startDate"
                        (ngModelChange)="b.startDate=$event"
                        ></ed-datepicker>
                </div>
                <div class="col-sm-2">
                    <ed-datepicker
                        id="endDate"
                        [ngModel]="b.endDate"
                        (ngModelChange)="b.endDate=$event"
                        ></ed-datepicker>
                </div>

                <div class="col-sm-2">
                    <ed-select
                        id="subscriptionBillingTiming"
                        [ngModel]="b.subscriptionBillingTiming"
                        (ngModelChange)="b.subscriptionBillingTiming=$event"
                        [options]="subscriptionBillingTimingOptions"
                        ></ed-select>
                
                </div>
                
                <div class="col-sm-2">
                    <ed-numberfield
                        id="amountExclTax"
                            [ngModel]="b.amountExclTax"
                            (ngModelChange)="b.amountExclTax=$event"
                        unit="€ HT"
                        >
                    </ed-numberfield>
                </div>
                
                <div class="col-sm-1 ">
                    <ed-checkbox
                        id="isSent"
                        [(checked)]="b.isSent!"
                            >
                    </ed-checkbox>
                </div>
                <div class="col-sm-1">
                    <ed-textfield
                        id="invoiceNumber"
                            [ngModel]="b.invoiceNumber"
                            (ngModelChange)="b.invoiceNumber=$event"
                        >
                    </ed-textfield>
                </div>
                <div class="col-sm-2">
                    <ed-textfield
                        id="comment"
                            [ngModel]="b.comment"
                            (ngModelChange)="b.comment=$event"
                        >
                    </ed-textfield>
                </div>
            </div>
        }
    <br/>
    <div class="row">
        <div class="col-sm-12 offset-md-5 col-md-2">
            <ed-button (click)="addLine()">
                Ajouter une ligne
            </ed-button>
        </div>
    </div>
    </div>
    <br/>    
</div>

<div class="layer-actions">
    <ed-button [colorSchema]="buttonColors.Secondary" (click)="close()">Retour</ed-button>
    <ed-button (click)="valid()" [disabled]="isDirty()">Valider</ed-button>
</div>
@if(projectSubcontractingAmountMismatch()){
        <label>
            <i style="color: red">La somme des factures prévisionnelles ({{getSumFormatted()}} €HT) ne correspond pas au montant vendu de la mission ( {{project?.subcontractingAmount }} €HT) :  {{getSum()- (project?.subcontractingAmount||0)}} €HT
            </i>
        </label>
    }